// extracted by mini-css-extract-plugin
export var card = "Card-module--card--KRI14";
export var card_right = "Card-module--card_right--F0JVN";
export var card_left = "Card-module--card_left---LAoA";
export var devider = "Card-module--devider--u0qh2";
export var content = "Card-module--content--w3npm";
export var link_wrap = "Card-module--link_wrap--DhTPZ";
export var img_wrap = "Card-module--img_wrap--QqQK6";